import type { Angebot, ApiClient } from "@kundeninfo/api-client";
import { apiMeldung } from "../vorgangsdetail.js";
import { SUCCESSION_TEXT } from "./texts.js";

/** Der Anker am Kopf der jüngsten Version einer Reihe: Ein Nachfolge-Chip springt in der Akte dorthin (Aufgabe 27). Auch
 *  das historische Detail trägt ihn — ein historisches Angebot hat genau eine Version (A-W2). */
export const seriesAnchorId = (seriesId: string): string => `offer-series-${seriesId}`;

/**
 * Ein Nachfolge-Chip springt zur Reihe: In der Akte steht sie als eigene Karte (Anker am Kopf ihrer jüngsten Version) —
 * dorthin rollen und den Fokus setzen, ohne ein zweites Mal zu rollen. Sonst (im Bereich) schlägt der Rahmen sie über
 * `onErsetzt` auf, wie nach „Kopieren“; ein Ladefehler geht als Hinweis an den Rahmen.
 */
export async function jumpToSeries(offer: Angebot, offerId: string, frame: {
  client: Pick<ApiClient, "getOffer">; kundeId: string;
  onErsetzt: (a: Angebot) => void; onHinweis: (text: string | null) => void;
}): Promise<void> {
  const ref = [offer.replaces, ...offer.replacedBy].find((r) => r?.offerId === offerId);
  const anchor = ref === undefined || ref === null ? null : document.getElementById(seriesAnchorId(ref.seriesId));
  if (anchor !== null) {
    anchor.scrollIntoView({ block: "nearest" });
    anchor.focus({ preventScroll: true });
    return;
  }
  try {
    frame.onErsetzt(await frame.client.getOffer(frame.kundeId, offerId));
  } catch (e) {
    frame.onHinweis(apiMeldung(e, SUCCESSION_TEXT.openFailed));
  }
}
